import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image, ScrollView } from 'react-native';
import { I18n, Utils, FormInput, AddButton, Panel, Select, ActionButton } from '../../components';
import { THEME, __WEB__, COLOR, FONT, SELECT_STYLE_ROUND } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import { saveEmployerSetupData, deleteEmployerSetupData } from '../../employer/actions';
import MedicalServices from './clinical_locations_medical_services';
import * as ASSETS from '../../../constants/assets';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';

export default memo(
  connect(
    function (state, ownProps) {
      const employer = getCurrentEmployer(state);
      const items =
        state.screens.employer.setupData?.clinicalLocations?.slice()?.sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        }) || [];
      return {
        employer,
        items,
        options: items.map((cl) => ({ id: cl.employer_clinical_location_id, label: cl.name })),
        saveSetupDataStatus: state.screens.employer.saveSetupDataStatus,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ saveEmployerSetupData, deleteEmployerSetupData }, dispatch),
      };
    }
  )(function (props) {
    const selected = props.options[0] || null;
    const [selectedLocation, setSelectedLocation] = useState(selected);
    const [editing, setEditing] = useState(false);
    const [text, setText] = useState('');

    useEffect(
      function () {
        if (props.saveSetupDataStatus === SUCCESS) {
          if (text) {
            const selectedOption = props.options.find((o) => o.label === text);
            if (selectedOption) {
              setSelectedLocation(selectedOption);
              setText('');
            }
          }
        }
        if (!selectedLocation || !props.options.find((o) => o.id === selectedLocation.id)) {
          setSelectedLocation(props.options[0] || null);
        }
      },
      [props.options]
    );

    function handleChangeText(text) {
      setText(text);
    }
    function handleSubmitEditing() {
      if (text?.trim()) {
        props.actions.saveEmployerSetupData(props.employer.employerId, 'clinicalLocations', {
          names: [text.trim()],
        });
      }
      setEditing(false);
    }
    function cancelEditing() {
      setText('');
      setEditing(false);
    }
    function handleAddPress() {
      setEditing(true);
    }
    function doDelete() {
      props.actions.deleteEmployerSetupData(
        props.employer.employerId,
        'clinicalLocations',
        selectedLocation.id
      );
    }
    function handleDeletePress() {
      const confirmationOpts = {
        title: 'Delete this item?',
        confirm: 'Yes, Delete',
        onConfirmed: () => {
          doDelete();
        },
      };
      props.onConfirmationOpts(confirmationOpts);
    }
    function handleSelect(value) {
      setSelectedLocation(value);
    }

    function renderAddButton() {
      if (!props.canEdit) return null;
      return (
        <AddButton
          label="ADD"
          onPress={handleAddPress}
          containerStyle={{ height: 40, paddingRight: 10, marginLeft: 10 }}
        />
      );
    }

    const selectedItem =
      selectedLocation &&
      props.items.find((i) => i.employer_clinical_location_id === selectedLocation.id);

    return (
      <Panel
        title={'Clinical Locations'}
        collapsable={props.collapsable}
        containerStyle={props.containerStyle}
        extraHeaderContent={renderAddButton()}
      >
        <View style={{ height: __WEB__ ? 300 : 'auto' }}>
          <View style={styles.locationContainer}>
            <View style={styles.selectContainer}>
              {!!editing ? (
                <View style={{ paddingLeft: 20 }}>
                  <FormInput
                    label="Clinical Location"
                    value={text}
                    autoFocus={true}
                    onChangeText={handleChangeText}
                    onSubmitEditing={handleSubmitEditing}
                    onBlur={!!__WEB__ ? handleSubmitEditing : cancelEditing}
                    placeholderTextColor={COLOR.textLight}
                    returnKeyType={'go'}
                  />
                </View>
              ) : (
                <View style={{ paddingLeft: __WEB__ ? 0 : 10 }}>
                  <Select
                    flexibleHeight={true}
                    onValue={handleSelect}
                    required={false}
                    closeOnSelect={true}
                    options={props.options}
                    label={null}
                    value={selectedLocation}
                    webMode={true}
                    isClearable={false}
                    containerStyle={{ marginVertical: 0 }}
                    noLabel={true}
                    styles={SELECT_STYLE_ROUND}
                    valueStyle={{ ...FONT.regular, fontSize: 14, color: 'rgb(60, 60, 60)' }}
                  />
                </View>
              )}
            </View>
            <View style={styles.buttonsContainer}>
              <View style={[THEME.basicRow, { flexGrow: 1, paddingLeft: 30 }]}>
                <Image
                  style={{ width: 13, height: 14 }}
                  source={require('../../../../resources/staff-icon-small.png')}
                />
                <Text style={[THEME.textBold, { fontSize: 10, paddingLeft: 6 }]}>
                  {selectedItem?.count}
                </Text>
              </View>
              <ActionButton
                source={ASSETS.reject}
                disabled={
                  !props.canEdit || !!parseInt(selectedItem?.count) || !selectedItem || editing
                }
                onPress={handleDeletePress}
              />
            </View>
          </View>
          <MedicalServices
            selectedLocationId={selectedLocation?.id}
            selectedLocationName={selectedLocation?.label}
            onConfirmationOpts={props.onConfirmationOpts}
            canEdit={props.canEdit}
          />
        </View>
      </Panel>
    );
  })
);

const styles = StyleSheet.create({
  locationContainer: {
    ...THEME.basicRow,
    borderBottomWidth: 2,
    borderColor: COLOR.accent,
    zIndex: 1000,
    padding: 10,
  },
  medicalServicesContainer: {
    flex: 1,
  },
  selectContainer: {
    flex: 0.75,
  },
  buttonsContainer: {
    ...THEME.basicRow,
    ...THEME.rowButtons,
    flex: 0.5,
    justifyContent: 'flex-end',
  },
  input: {
    ...THEME.input,
    height: 30,
    borderWidth: 1,
    borderColor: COLOR.accent,
    backgroundColor: COLOR.contrast,
    fontSize: __WEB__ ? 12 : 12,
  },
  sectionHeaderColumn: {
    ...THEME.sectionHeaderColumn,
    paddingVertical: 10,
  },
});
